import React from 'react';
import { DatePicker } from 'antd';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
const { RangePicker } = DatePicker;
/**
 * * 데이트 피커 - 기간
 */

interface IProps {
  format?: string;
  showTime?: boolean;
  value?: string[] | any;
  ranges?: any;
  onChange?: (e: any, v: string[]) => void;
  defaultValue?: any;
  defaultPickerValue?: any;
  style?: React.CSSProperties;
  title?: string;
}
const RangeDatePicker = ({
  format,
  showTime,
  value,
  ranges,
  onChange,
  defaultValue,
  defaultPickerValue,
  style,
  title,
}: IProps) => {
  return (
    <Wrapper title={title} style={style}>
      <label>{title}</label>
      <RangePicker
        style={style}
        onChange={onChange}
        format={format}
        defaultPickerValue={defaultPickerValue}
        defaultValue={defaultValue}
        value={value}
        showTime={showTime}
        ranges={ranges}
        showSecond={false}
      >
        데이트 피커 기간 조정
      </RangePicker>
    </Wrapper>
  );
};

export default RangeDatePicker;
const Wrapper = styled.div`
  width: 100%;
  label {
    display: ${(props) => (props.title ? 'block' : 'none')};
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.5rem;
    margin-bottom: 0.2rem;
  }
  .ant-picker {
    /* border: none; */
  }
`;
